import { isGuestCheckoutTraffic } from 'lib/checkout/guestCheckout'

export const LERE_DYNAMIC_PRICING_EXCLUSION_COOKIE = 'DP_EXCLUSION_COOKIE'

interface LereDynamicPricingExclusionInput {
  utmBp?: string
  isGuestCheckout?: boolean
  isSessionExcluded?: boolean
}

/** Guest-checkout traffic and admitted guest carts retain base Flash pricing for the session. */
export function shouldExcludeLereDynamicPricing({
  utmBp,
  isGuestCheckout,
  isSessionExcluded,
}: LereDynamicPricingExclusionInput): boolean {
  return isGuestCheckoutTraffic(utmBp) || !!isGuestCheckout || !!isSessionExcluded
}

export function isLereDynamicPricingExcluded(state: App.State): boolean {
  return shouldExcludeLereDynamicPricing({
    utmBp: state.router?.location?.query.utm_bp ?? state.utm?.bp,
    isGuestCheckout: state.checkout?.cart?.isGuestCheckoutMode,
    isSessionExcluded: state.system?.lereDynamicPricingExcluded,
  })
}

/** Explicit or delayed request overrides must obey the same exclusion as displayed prices. */
export function getLereDynamicPricingGroupForRequest(state: App.State, lereGroup?: string): string | undefined {
  return isLereDynamicPricingExcluded(state) ? undefined : lereGroup
}
